<template>
  <div class="doorpostdescribe">
    <div class="header">
      <div class="title">无人门岗硬件描述</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="left">
        <img :src="doorpostdescribeLogo" alt="" />
      </div>
      <div class="right">
        <div class="title">系统功能</div>
        <div class="text">
          通过智能无人门岗：人脸识别或刷卡、防疫测温、人数统计、预约登记、访客自助登机、临时二维码、临时密码，自助大屏查询小区资讯、缴纳物业费、水电费、停车费、空余车位、使通行更加方便、安全、便捷。可以完全替代目前人工门岗功能。
        </div>
        <div class="item-title">优势</div>
        <div class="list">
          <div class="item" v-for="item in list" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import doorpostdescribeLogo from "../../../../assets/programme/doorpostdescribeLogo.png";
import yesLogo from "../../../../assets/programme/yesLogo.png";

export default {
  setup() {
    return reactive({
      doorpostdescribeLogo: doorpostdescribeLogo,
      list: [
        {
          id: 1,
          title: "3D人脸识别，可多角度识别",
          logo: yesLogo,
        },
        {
          id: 2,
          title:
            "适应能力强，不管是室内弱光环境还是室外的强光照射，都可以无死角识别",
          logo: yesLogo,
        },
        {
          id: 3,
          title: "防尘防水，不惧恶劣环境",
          logo: yesLogo,
        },
        {
          id: 4,
          title: "可认证对比，实现多功能兼容编辑认证对比",
          logo: yesLogo,
        },
        {
          id: 5,
          title: "可远距离活体检测",
          logo: yesLogo,
        },
        {
          id: 6,
          title: "远距离提问检查功能",
          logo: yesLogo,
        },
      ],
    });
  },
};
</script>

<style scoped>
.doorpostdescribe {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.body .left img {
  width: 606px;
}
.body .right {
  width: 500px;
}
.body .right .title {
  font-size: 16px;
  color: #333;
}
.body .right .text {
  font-size: 14px;
  color: #3d3d3d;
  margin-top: 20px;
}
.body .right .item-title {
  margin-top: 40px;
  color: #333;
  font-size: 16px;
}
.body .right .list .item {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.body .right .list .item img {
  width: 18px;
  margin-right: 10px;
}
.body .right .list .item div {
  font-size: 14px;
  color: #2a3d50;
}
</style>
